export const MAIN_MENU = [
  {
    label: 'Logout',
    event: 'logOut'
  },
  {
    label: 'Delete Account',
    event: 'deleteAccount'
  }
]
